import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import 'lib/mobile_detect_wrapper';

import { Global } from '@emotion/react';
import { store } from 'data_system/resource_portal/configureStore';
import { history } from 'data_system/resource_portal/history';
import { cssReset } from 'ui_system/token_auth/styles_root';
import ResourcePortal from './ResourcePortal';

export function Root(initialProps) {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Global styles={cssReset({})} />
        <ResourcePortal {...initialProps} />
      </ConnectedRouter>
    </Provider>
  );
}
